import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GenericService } from 'src/app/services/generic/generic.service';

@Component({
  selector: 'app-consultas-log-list',
  templateUrl: './consultas-log-list.component.html',
  styleUrls: ['./consultas-log-list.component.css']
})
export class ConsultasLogListComponent implements OnInit {

  public mostrar = false;
  public control: any = [];
  public showDuplicate: boolean = true;
  public anchoTabla = "1500px";  
  public columnasVisibles: boolean = false;
  public selectedColumns: any[];
  public displayMultiple: any;
  public display: boolean = false;
  public expression = false;
  public title = "Packs";
  public listarTodos: boolean = true;
  public mostrarInformes: boolean = true;
  public showInfo: boolean = true;

  public database = "usuarios_logs";
  public database_origen = "usuarios_logs";

  public mydt: any;

  public cols = [
    {header: 'Fecha', field: 'fecha'},
    {header: 'Hora', field: 'hora'},
    {header: 'Usuario', field: 'usuario'},
    {header: 'IP', field:'ip_origen'},
    {header: 'Navegador', field: 'user_agent'},
  ];

  constructor(
    private genericService: GenericService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) {
    this.showCols();
  }

  ngOnInit() {
    this.iniciar();
  }

  showCols(){

    this.columnasVisibles = false;
    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  
  }

  
  iniciar() {
    this.mostrar = false;
    this.genericService.getListSimple( this.database,"").toPromise().then((data: any) => {
    
      this.control = data.productos;
      this.mostarTabla();
      
    }).catch(error => {
      console.log("Error", error);
    });
  }

  mostarTabla() {
    this.mostrar = true;
  }

  listarCampos() {

      this.columnasSimples();

  }

  columnasSimples() {
    this.columnasVisibles = false;
    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  }

  cerrar() {
    this.display = false;

    this.expression = false;
  }

  closeWindow(event) {
    this.cerrar();
  }


  closeWindowMultpile(event) {
    this.consultar();
  }
  consultar() {

    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple = true;
    }
    if (this.mydt == null || this.mydt == undefined || this.mydt == 'object' || this.mydt.length == 0) {

    } else if (this.mydt.filteredValue == null || this.mydt == undefined) {

    } else {

    }
  }  

  cambios(dt) {

    this.mydt = dt;

  }

  delete(id) {
    this.confirmationService.confirm({
      header: 'Confirmación',
      acceptLabel: 'Acceptar',
      rejectLabel: 'Cancelar',
      message: 'Quieres eliminar este registro?',
      accept: () => {
  
        this.genericService.delete( id, this.database_origen ).subscribe(data => {
          // console.log("Ha ido bien",data);
          this.iniciar();
        }, error => {
          console.error("error ", error);
        });
      }
    });

  }

  duplicate(transporte) {
    let newId = "";
    this.genericService.clone(transporte.id, this.database_origen).toPromise().then((data:any) => {
     
      newId = data.id;

      this.messageService.add({ severity: 'success', summary: `Registro ${this.database_origen}`, detail: `Registro ${this.database_origen} Duplicado` });
      this.iniciar();
    }).catch(error => {
      this.messageService.add({ severity: 'error', summary: `Registro ${this.database_origen}`, detail: `Error en registro ${this.database_origen}` });
      console.log("error", error);
    });
  }

}
